import { render, staticRenderFns } from "./groupon_choose_sex.vue?vue&type=template&id=00156864&scoped=true&"
import script from "./groupon_choose_sex.vue?vue&type=script&lang=js&"
export * from "./groupon_choose_sex.vue?vue&type=script&lang=js&"
import style0 from "./groupon_choose_sex.vue?vue&type=style&index=0&id=00156864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00156864",
  null
  
)

export default component.exports